import { Button, Stack, Box, Checkbox, Slide } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { tease } from "../components/CheckButton";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import {
  ActionType,
  Color,
  ContactType,
  defaultInnerStyle,
  ErrorCode,
  FontStyle,
  navPaddingTop,
  SignupFor,
  Slug,
  SurveyButtonStyle,
} from "../constants";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { StyledTextField } from "../components/AutocompleteUtils";
import * as apiService from "../service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import googleIcon from "../img/googleIcon.png";
import { useNavigate } from "react-router-dom";
import Confetti from "../components/Confetti";

// signup redirect from Fetti University

const styles = {
  outer: {
    paddingTop: navPaddingTop,
    backgroundColor: "#fff",
    minHeight: "100vh",
  },
  container: {
    paddingTop: "1.5rem",
    height: "100%",
    px: 3,
    maxWidth: "100vw",
  },
  inner: {
    ...defaultInnerStyle,
    margin: "auto",
    paddingBottom: "50px",
    "& .MuiFormControl-root": {
      border: "none",
    },
  },

  subtitle: {
    ...FontStyle.body,
    fontSize: { xs: "24px", sm: "30px" },
    textAlign: "center",
  },
  title: {
    ...FontStyle.body,
    fontSize: { xs: "32px", sm: "48px" },
    textAlign: "center",
    textDecoration: "underline",
  },
  body: {
    ...FontStyle.body,
    fontSize: "0.83rem",
    textAlign: "left",
    lineHeight: "1.4",
    maxWidth: "500px",
    "& > * >a": {
      color: "#000",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  label: {
    ...FontStyle.headingBody,
    fontSize: { xs: "14px", sm: "1rem" },
    // lineHeight: "1.4",
    width: "100%",
    maxWidth: "500px",
  },
  search: {
    width: "100%",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "4px",
    border: "1px solid rgb(204, 204, 204)",
  },
  searchProps: {
    disableUnderline: true,
  },
  error: {
    ...FontStyle.body,
    color: "red",
    fontSize: "0.75rem",
    textAlign: "left",
    width: "100%",
  },
  success: {
    ...FontStyle.body,
    color: "green",
    fontSize: "16px",
    textAlign: "center",
    width: "100%",
  },
  googleCustomButton: {
    textTransform: "none",
    fontFamily: '"Google Sans",arial,sans-serif',
    fontWeight: "500",
    height: "46px",
    width: "100%",
    border: "1px solid #dadce0",
    color: "#202124",
    "&:hover": {
      border: "1px solid #d2e3fc",
    },
  },
  signupWithEmailText: {
    ...FontStyle.headingBody,
    fontSize: { xs: "16px", sm: "1.2rem" },
    lineHeight: "1.4",
    width: "100%",
    maxWidth: "500px",
    textAlign: "center",
    paddingTop: 1,
  },
  orText: {
    ...FontStyle.body,
    fontSize: "1rem",
    // px: '1rem',
    textAlign: "center",
    opacity: "0.4",
  },
  bar: {
    width: "100%",
    height: "1px",
    backgroundColor: "#000",
    opacity: "0.2",
  },
};
const EduSignupSuccess = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const signupFor = queryParameters.get("for");
  const forAffiliate = signupFor === SignupFor.affiliate;
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  return (
    <Box sx={styles.outer}>
      <Confetti />
      <Box sx={styles.container}>
        <Slide
          direction="down"
          in={true}
          mountOnEnter
          unmountOnExit
          timeout={1500}>
          <Stack
            direction="column"
            sx={styles.inner}
            alignItems="left"
            justifyContent="center"
            spacing={4}>
            <Box sx={styles.title}>Sign Up Success</Box>
            {!forAffiliate && (
              <>
                <Box sx={styles.subtitle}>
                  Welcome to Fetti University, {auth.accountData.firstName}!
                </Box>
                <Button
                  sx={{
                    ...SurveyButtonStyle.defaultStyling,
                    ...SurveyButtonStyle.primaryColor,
                    // ...SurveyButtonStyle.gradientColor,
                    // textTransform: "none",
                    // fontWeight: "normal",
                  }}
                  disableRipple
                  fullWidth
                  onClick={() => {
                    navigate({
                      pathname: Slug.education + "/",
                      search: "?" + queryParameters.toString(),
                    });
                  }}>
                  My Career Resources
                </Button>
              </>
            )}
            {forAffiliate && (
              <>
                <Box sx={styles.subtitle}>
                  Welcome to Fetti Affiliate, {auth.accountData.firstName}!
                </Box>
                <a href={Slug.affiliateSite}>
                  <Button
                    sx={{
                      ...SurveyButtonStyle.defaultStyling,
                      ...SurveyButtonStyle.primaryColor,
                      // ...SurveyButtonStyle.gradientColor,
                      // textTransform: "none",
                      // fontWeight: "normal",
                    }}
                    disableRipple
                    fullWidth>
                    To My Dashboard
                  </Button>
                </a>
              </>
            )}
          </Stack>
        </Slide>
      </Box>
    </Box>
  );
};

export default EduSignupSuccess;
